export default "__VITE_ASSET__BzV0$lAG__"